
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[publicId]/reviews",
      function () {
        return require("private-next-pages/[publicId]/reviews/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[publicId]/reviews"])
      });
    }
  